export function fieldErrorMessage(error: unknown): string {
  if (!error || typeof error !== "object") return "";

  const message = "message" in error ? error.message : undefined;
  if (typeof message === "string" && message) return message;

  for (const [key, value] of Object.entries(error)) {
    if (key === "ref" || key === "type" || key === "types") continue;
    const nested = fieldErrorMessage(value);
    if (nested) return nested;
  }

  return "";
}
